import { IStoreRootState } from "@/store/interface";
import { GetterTree } from "vuex";
import { PaymentRequirementsIncomingGetter } from "./constants";
import { PaymentRequirementsIncomingState } from "./interface";

export default <GetterTree<PaymentRequirementsIncomingState, IStoreRootState>> {

	[PaymentRequirementsIncomingGetter.unprocessedList]: (
		{ unprocessedList }
	) => unprocessedList,

	[PaymentRequirementsIncomingGetter.unprocessedListLoading]: (
		{ unprocessedListLoading }
	) => unprocessedListLoading,

	[PaymentRequirementsIncomingGetter.unprocessedListShowed]: (
		{ unprocessedListShowed }
	) => unprocessedListShowed,

	[PaymentRequirementsIncomingGetter.unprocessedCount]: (
		{ unprocessedList }
	) => unprocessedList.length,

	[PaymentRequirementsIncomingGetter.cardIndexDetails]: (
		{ cardIndexDetails }
	) => cardIndexDetails,

}